import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class TermosGeraisService {
  constructor(private http: HttpClient) {}

  getAceito(): Observable<boolean> {
    return this.http.get<boolean>('/api/termos-de-uso/geral/aceito').pipe(take(1))
  }

  saveAceitouTermos(): Observable<Object> {
    return this.http.post('/api/termos-de-uso/geral/aceitar', true).pipe(take(1))
  }
}
